var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-16 lg:h-24 2xl:h-32 grid grid-cols-12 place-content-center gap-x-4",
    class: {
      'bg-gray-300 opacity-30 cursor-not-allowed': _vm.disabled,
      'odd:bg-indigo-100 odd:bg-opacity-50 hover:bg-indigo-200 cursor-pointer': !_vm.disabled
    },
    on: {
      "mouseenter": function ($event) {
        _vm.hover = true;
      },
      "mouseleave": function ($event) {
        _vm.hover = false;
      }
    }
  }, [_c('div', {
    staticClass: "col-span-2 md:col-span-1 text-pink-600 flex justify-center place-self-center"
  }, [!_vm.disabled ? _c('icon', {
    attrs: {
      "name": "eye"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 md:col-span-2 text-base justify-self-start place-self-center"
  }, [_vm._v("\n    " + _vm._s(_vm.closedAt) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 md:col-span-3 text-base justify-self-start place-self-center"
  }, [_vm._v("\n    " + _vm._s(_vm.startedAt) + " - " + _vm._s(_vm.endedAt) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden md:block col-span-3 text-base justify-self-start place-self-center max-w-full"
  }, [_vm.referent != null ? _c('div', [_c('p', {
    staticClass: "truncate"
  }, [_vm._v("\n        " + _vm._s(_vm.referent.firstname) + "\n        "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.referent.lastname))])]), _vm._v(" "), _c('p', {
    staticClass: "truncate"
  }, [_vm._v("\n        " + _vm._s(_vm.referent.role) + "\n      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hidden md:block col-span-3 text-sm md:line-clamp-2 pr-5 italic justify-self-start place-self-center"
  }, [_c('p', {
    staticClass: "break-all"
  }, [_vm._v("\n      " + _vm._s(_vm.itemsLibelles) + "\n    ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }